import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getMailSyncService } from '../server/mailSyncServiceHolder.js';
import { getCurrentUserID } from './currentUserID.js';

/**
 * Triggers an immediate mailbox sync (manual "refresh") instead of waiting for the next
 * polling interval. Resolves once the fetch completes — the mail subscription then picks
 * up any newly imported mails reactively. Returns false if the sync service isn't running.
 */
export const triggerMailSync = registerMutation({
  type: () => Boolean,
  operationName: 'triggerMailSync',
  resolve: () => {
    return async () => {
      const userID = getCurrentUserID();
      if (!userID) throw new Error('Nicht angemeldet');
      const service = getMailSyncService();
      if (!service) return false;
      await service.triggerSync();
      return true;
    };
  },
  params: [],
});
